// Core
import React from 'react'

// Library
import clsx from 'clsx'

// Components
import { ReactComponent as CheckCircle } from 'assets/icons/check_circle.svg'

// Styles
import classes from 'components/Onboarding/BulletList/BulletList.module.scss'

// Interface
interface IBulletListProps {
  features: string[]
}

export default function BulletList({
  features,
}: IBulletListProps) {
  return (
    <div className={clsx(classes.container)}>
      <ul>
        {features.map((feat) => (
          <li key={feat}>
            <div  className="d-flex shrink-0">
              <CheckCircle />
            </div>
            <span className="d-flex">
              {feat}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
